import { render, staticRenderFns } from "./Lang.vue?vue&type=template&id=46185665&scoped=true"
import script from "./Lang.vue?vue&type=script&lang=js"
export * from "./Lang.vue?vue&type=script&lang=js"
import style0 from "./Lang.vue?vue&type=style&index=0&id=46185665&prod&lang=css"
import style1 from "./Lang.vue?vue&type=style&index=1&id=46185665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46185665",
  null
  
)

export default component.exports